// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"214":"dd3ea9e8","453":"c29ab0ce","565":"221da895","631":"ce89bfca","695":"bf4bff97","819":"1a441602"}[chunkId] + ".chunk.js";
};